import { PrimitiveType } from "intl-messageformat";
import { createIntl, createIntlCache } from "react-intl";
import { generalStore } from "../stores/GeneralStore";
import deMessages from "./data/de.json";
import enMessages from "./data/en.json";
import { Locales } from "./Locales";

const DEFAULT_LOCALE = "de";

type Messages = {
    [locale in Locales]: {
        [message: string]: string;
    };
};

const intlMessages: Messages = {
    en: enMessages,
    de: deMessages
};

type AvailableI18nIds = typeof deMessages;

const cache = createIntlCache();

let intl = createIntl(
    {
        locale: DEFAULT_LOCALE,
        messages: intlMessages[DEFAULT_LOCALE]
    },
    cache
);

export type MessageIDS = keyof AvailableI18nIds;

const setLocale = (locale: Locales) => {
    intl = createIntl(
        {
            locale: locale,
            messages: intlMessages[locale]
        },
        cache
    );

    generalStore.locale = locale;

    console.log(`%cSet locale to "${locale}".`);
};

const t = (messageId: MessageIDS, values?: Record<string, PrimitiveType>) => {
    return intl.formatMessage({ id: messageId }, values);
};

export { DEFAULT_LOCALE, intl, intlMessages, setLocale, t };
